// eslint-disable-next-line no-use-before-define
import React from 'react';
import { SvgVideoMessageBySendsparkLogo } from '@assets/SvgVideoMessageBySendsparkLogo';
import LogoLink from '@components/Layout/styles/LogoLink';
import Text from './styles/Text';
import VideoRequestByWrapper from './styles/VideoRequestByWrapper';

interface VideoRequestByProps {
  iconColor?: string;
  iconTextColor?: string;
  textColor?: string;
  trackViralLink: (url?: string) => Promise<void>;
}

const VideoRequestBy: React.FunctionComponent<VideoRequestByProps> = ({
  iconColor,
  iconTextColor,
  textColor,
  trackViralLink,
}) => (
  <VideoRequestByWrapper>
    <Text color={textColor}>Video Request by</Text>
    <LogoLink
      onClick={() => trackViralLink()}
      className="logo-link"
      target="_blank"
      rel="noreferrer"
    >
      <SvgVideoMessageBySendsparkLogo
        iconColor={iconColor}
        textColor={iconTextColor}
      />
    </LogoLink>
  </VideoRequestByWrapper>
);

export default VideoRequestBy;
